import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import PurchaseCreditNoteRegisterForm from '../components/PurchaseCreditNoteRegisterForm';
import { useCreatePurchaseCreditNoteRegisterHandler } from '../dataHandlers/createPurchaseCreditNoteRegisterHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_PURCHASE_REGISTER } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

export default function CreatePurchaseCreditNoteRegisterPage() {
  const { purchaseInvoiceRegister } = useTranslatedMessages();
  useDocumentTitle(
    purchaseInvoiceRegister?.pages?.create_title_credit_note ?? 'Create Purchase Credit Note Register Entry',
  );
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();

  useEffect(() => {
    if (loading) return;
    if (!hasEInvoicePermission(CREATE_PURCHASE_REGISTER)) {
      showActionDeniedSnackbar();
      navigate('/purchase-invoice-register?tab=credit-notes', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  const onRegisterCreated = () => {
    navigate('/purchase-invoice-register?tab=credit-notes');
  };

  const { onSubmit, error, isPending } = useCreatePurchaseCreditNoteRegisterHandler({ onSuccess: onRegisterCreated });

  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const onSaveForm = (data) => {
    setIsSubmitting(true);
    onSubmit(data);
  };

  const onCancel = () => {
    navigate('/purchase-invoice-register?tab=credit-notes', { replace: true });
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <PurchaseCreditNoteRegisterForm
        initialData={{}}
        onSubmit={onSaveForm}
        onCancel={onCancel}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
